import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { CatalogObjectTypeModel } from '../models'

export interface CatalogueObjectType extends CatalogObjectTypeModel {
    new?: boolean
    key?: string
    code?: string
    maxNumberForLinksPerEyewear?: string
}
const url = `/libraries/management/types/catalogObjectType/entries`
@Injectable()
export class CatalogueObjectTypeService {
    constructor(private http: HttpService) {}

    getAll(): Observable<CatalogueObjectType[]> {
        return this.http.get<CatalogueObjectType[]>(url)
    }

    remove(data: CatalogueObjectType[]): Observable<void> {
        return this.http.delete(url, { data })
    }

    create(data: CatalogueObjectType[]): Observable<CatalogueObjectType[]> {
        return this.http.post<CatalogueObjectType[]>(url, { data })
    }
    update(data: CatalogueObjectType[]): Observable<CatalogueObjectType[]> {
        return this.http.put<CatalogueObjectType[]>(url, { data })
    }
}
